import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';

import { TableSkeleton } from '@eluve/blocks';
import { Stack, Text } from '@eluve/components';

import { PatientAppointmentsList } from '../PatientAppointmentsList';

export const PatientAppointmentsTab: React.FC = () => {
  return (
    <Suspense fallback={<TableSkeleton rowCount={20} />}>
      <ErrorBoundary
        fallback={
          <Stack gap={2}>
            <Text>Failed to load appointment data.</Text>
            <TableSkeleton rowCount={5} />
          </Stack>
        }
      >
        <PatientAppointmentsList />
      </ErrorBoundary>
    </Suspense>
  );
};
